import { BaseModel } from "sjs-base-model";
import PreventivoModel from "../../preventivo/models/PreventivoModel";
import RichiestaDatiAnagraficiRequestModel from "./RichiestaDatiAnagraficiRequestModel";
import RichiestaAltriPrestitiRequestModel from "./RichiestaAltriPrestitiRequestModel";
import RichiestaDatiRedditoRequestModel from "./RichiestaDatiRedditoRequestModel";
import RichiestaDocumentiViewModel from "./RichiestaDocumentiViewModel";
import CqsOnlineRichiestaSezioneDocumentiViewModel from "stores/cqsonline/models/CqsOnlineRichiestaSezioneDocumentiViewModel";
import RichiestaConcludiRequestModel from "./RichiestaConcludiRequestModel";
import RichiestaAdeguataVerificaRequestModel from "./RichiestaAdeguataVerificaRequestModel";

export default class RichiestaModel extends BaseModel {
    public readonly preventivo: PreventivoModel = new PreventivoModel({});
    public readonly datiAnagrafici?: RichiestaDatiAnagraficiRequestModel;
    public readonly datiReddito?: RichiestaDatiRedditoRequestModel;
    public readonly altriPrestiti?: RichiestaAltriPrestitiRequestModel;
    public readonly adeguataVerifica?: RichiestaAdeguataVerificaRequestModel;
    public readonly documentiDaCaricare?: CqsOnlineRichiestaSezioneDocumentiViewModel[];
    public readonly documentiFirmaDebole?: RichiestaDocumentiViewModel;
    public readonly documentiFirmaForte?: RichiestaDocumentiViewModel;
    public readonly idRichiesta: number = 0;
    public readonly stepRichiesta: string = "";
    public readonly dataInserimento: string = "";
    public readonly dataSospensione: string = "";
    public readonly statoRichiesta: string = "";
    public readonly isNuovaRichiesta: boolean = false;
    public readonly documentiDaFirmare?: CqsOnlineRichiestaSezioneDocumentiViewModel[];
    public readonly documentiDaFirmareIstruttoria?: CqsOnlineRichiestaSezioneDocumentiViewModel[];
    public readonly concludi: RichiestaConcludiRequestModel = new RichiestaConcludiRequestModel({});
    
    //public readonly steps: string ="";
    /*
     * Client-Side properties (Not from API)
     */
    // public noneApiProperties: unknown = null;
    constructor(data: Partial<RichiestaModel>) {
        super();

        this.update(data);
    }
}
